<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item :to="{ path: '/admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'agent_index' }">我的采购单</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="header-top-15"></div>

    <el-table
      :data="tableData.data"
      stripe
      style="width: 100%; margin-top: 10px"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column prop="id" label="ID" type="selection"> </el-table-column>
      <el-table-column prop="oid" label="订单号"> </el-table-column>
      <el-table-column prop="agent_user.username" label="用户" width="180">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :content="scope.row.agent_user.username"
            placement="top-start"
          >
            <span>{{ scope.row.agent_user.username }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="level" label="创建日期">
        <template slot-scope="scope">
          {{ formatGMT(scope.row.created_time) }}
        </template>
      </el-table-column>

      <el-table-column prop="totalprice" label="总价">
        <template slot-scope="scope">
          {{ scope.row.totalprice }}
        </template>
      </el-table-column>

      <el-table-column prop="agent" label="状态">
        <template slot-scope="scope">
          {{ scope.row.status }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="7">
              <el-button size="mini" @click="orderDetail(scope.row)">查看</el-button>
            </el-col>

            <el-col :span="7">
              <el-button size="mini">删除</el-button>
            </el-col>
            <el-col :span="7">
              <el-button size="mini">售后</el-button>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="tableData.totalpages"
          @current-change="changePage"
        >
        </el-pagination>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      multipleSelection: [],
      dialogFormVisible: false,
      dialogStoreVisible: false,
      agent: false,
      product_stock: {},
      dialog_msg_visible: false,
      dialog_restore_visible: false,
      page: 1,
      user_id: "",
    };
  },
  methods: {
    ...mapActions({
      getMyorderDataAction: "getMyorderDataAction",
    }),
    formatGMT(gmt, long) {
      long = false === long ? false : true;
      let date = new Date(gmt);

      let m = date.getMonth() + 1,
        mm = "-" + (m < 10 ? "0" + m : m);
      let d = date.getDate(),
        dd = "-" + (d < 10 ? "0" + d : d);
      let h = date.getHours(),
        hh = " " + (h < 10 ? "0" + h : h);
      let i = date.getMinutes(),
        ii = ":" + (i < 10 ? "0" + i : i);
      let s = date.getSeconds(),
        ss = ":" + (s < 10 ? "0" + s : s);

      return date.getFullYear() + mm + dd + (long ? hh + ii + ss : "");
    },
    handleEdit(index, row) {
      console.log(index, row);
      this.tableData[index].editeFlag = true;
      //alert(row['id']);
      this.tableData[index] = row;
    },
    handleUpdate(index, row) {
      this.tableData[index].editeFlag = false;
      this.tableData[index] = row;
      //alert(JSON.stringify(this.tableData[index]));
      //alert(row['id']);
    },
    orderDetail(row) {
      const id = row.id;

      this.$router.push({
        name: "order_detail",
        params: {
          id: id,
        },
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    changePage(e) {
      this.page = e;
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;

      console.log("tag", this.page);
      this.getMyorderDataAction({ page: page });
    },
  },
  created() {
    this.user_id = this.$route.params.user_id;

    this.getMyorderDataAction({ page: this.page, user_id: this.user_id });
  },
  //tableData
  computed: mapState({
    tableData: (state) => state.order.result,
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
